/**
 * Created by m.igrachev on 6/16/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Heading/subtitle supports ActionMenu as child. Other children will be ignored."
    },
    {
        name: "title",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The label of the heading/subtitle component."
    },
    {
        name: "textColor",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A text color to use for the heading/subtitle label. Supported for now: 'tq-orange', 'tq-red', 'tq-green'"
    },
    {
        name: "leftIcon",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A icon class name to be put on heading/subtitle label's left."
    },
    {
        name: "splitter",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Defines what splitter should be used. Supported for now: 'heavy', 'light'. Light is supported only for subtitle."
    },
    {
        name: "fontStyles",
        type: "Array",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Defines font styles. Applies only on h element. Supported for now are bold and italic."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: 'Extra css string classes to be applied on "h3" heading HTML element.'
    },
    {
        name: "subtitle",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true indicated that the heading should be displayed as a subtitle."
    }
];

export default documentedProperties;
